<script>
    import {onMount} from 'svelte';
    import Common from "./Common";
    import moment from "moment";
    import Summary from "./Summary.svelte";
    import RentTime from "./parts/RentTime.svelte";
    import Documents from "./parts/Documents.svelte";
    import Payment from "./parts/Payment.svelte";
    import Invoice from "./parts/Invoice.svelte";

    let rentFound = null;
    let rent = {};

    let mode = "summary";

    function updateMode(arg) {
        if (arg.detail) {
            mode = arg.detail.data;
        } else {
            mode = arg;
        }
        history.pushState({}, '', '/?id=' + rent.uuid);
    }

    //TODO: reload - 10 mins

    onMount(async () => {

        window.onpopstate = function() {
            updateMode('summary');
        };

        const urlParams = new URLSearchParams(location.search);
        let id = urlParams.get("id");
        if (!id || !id.length) {
            rentFound = false;
        } else {
            Common.getRent(id).then(function (response) {
                rent = response;
                rentFound = true;
                console.log(rent);
                let now = moment();
                let endDate = moment.unix(rent.endDate / 1000).utc().add(1, 'hours');
                rent.passed = now.isAfter(endDate);

                rent.dayDiff = endDate.diff(now, 'days');
                rent.hourDiff = (endDate.diff(now, 'hours')) % 24;

                rent.startDateStr = moment.unix(rent.startDate / 1000).utc().format("DD-MM-YYYY   HH:mm");
                rent.endDateStr = moment.unix(rent.endDate / 1000).utc().format("DD-MM-YYYY   HH:mm");

                rent.startDateDateStr = moment.unix(rent.startDate / 1000).utc().format("DD-MM-YYYY");
                rent.endDateDateStr = moment.unix(rent.endDate / 1000).utc().format("DD-MM-YYYY");

                rent.startDateTimeStr = moment.unix(rent.startDate / 1000).utc().format("HH:mm");
                rent.endDateTimeStr = moment.unix(rent.endDate / 1000).utc().format("HH:mm");

            }).catch(function (present) {
                rentFound = false;
            });
        }
    });
</script>

{#if rentFound === null}
    <main class="bg-white w-full h-full text-center pt-8">
        <i class="fas fa-cog fa-spin fa-3x blue-3"></i><br/>
        <div class="mt-8">
            <span class="fa-2x blue-3 drogowskazFont">Proszę czekać</span>
        </div>
    </main>
{/if}

{#if rentFound === false}
    <main class="bg-white w-full h-full text-center pt-8">
        <i class="fas fa-exclamation-circle fa-3x blue-3"></i><br/>
        <div class="mt-8">
            <span class="fa-2x blue-3 drogowskazFont">Ten link jest juz nieaktywny</span>
        </div>
        <div class="mt-8">
            <span class="fa-2x blue-3 drogowskazFont"> Zadzwoń pod numer <br/> <a href="tel:790444055"
                                                                                  class="underline">790-444-055</a></span>
        </div>
    </main>
{/if}

{#if rentFound === true}
    {#if mode === 'summary'}
        <Summary bind:rent={rent} on:mode={updateMode}></Summary>
    {:else if mode === 'rentTime'}
        <RentTime bind:rent={rent} on:back={() => updateMode('summary')}></RentTime>
    {:else if mode === 'documents'}
        <Documents bind:rent={rent} on:back={() => updateMode('summary')}></Documents>
    {:else if mode === 'payment'}
        <Payment bind:rent={rent} on:back={() => updateMode('summary')}></Payment>
    {:else if mode === 'invoice'}
        <Invoice bind:rent={rent} on:back={() => updateMode('summary')}></Invoice>
    {/if}
{/if}
